import { useAuth } from '../../context/AuthContext';
import AppLayout from './AppLayout';
import ProtectedRoute from './ProtectedRoute';
import LinksPage from '../LinksPage';
import Loader from '../ui/Loader';

function ProtectedLinksLayout() {
    return (
        <ProtectedRoute>
            <AppLayout showTopNav showBottomNav withNavPadding showFooter={false}>
                <LinksPage />
            </AppLayout>
        </ProtectedRoute>
    );
}

export default function LinksPageRoute() {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <AppLayout showHeader={false} bare showFooter={false}>
                <Loader text="Загрузка..." />
            </AppLayout>
        );
    }

    if (isAuthenticated) {
        return <ProtectedLinksLayout />;
    }

    return (
        <AppLayout showHeader={false} bare showFooter={false}>
            <LinksPage />
        </AppLayout>
    );
}
